<template>
  <div class="ndcl">
    <div v-if="loading" class="ndcl__loading">
      <div class="ndcl__spinner"></div>
    </div>
    <route-card-list v-else-if="mappedCruises.length" :routes="mappedCruises" />
    <button v-if="!loading && hasMore" class="ndcl__more" @click="loadMore">{{ $t('cruises.list.load_more') }}</button>
  </div>
</template>

<script>
import axios from 'axios'
import RouteCardList from '../components/RouteCardList.vue'

export default {
  name: 'NewsDetailCruiseList',
  components: { RouteCardList },
  props: {
    filter: { type: Object, default: function () { return {} } },
  },
  data() {
    return {
      cruises: [],
      page: 1,
      lastPage: 1,
      loading: true,
    }
  },
  computed: {
    hasMore: function () { return this.page < this.lastPage },
    mappedCruises: function () {
      var self = this
      var months = [
        'янв','фев','мар','апр','мая','июн','июл','авг','сен','окт','ноя','дек',
      ]
      try {
        var locale = (window.transferState && window.transferState.get('i18n') || {}).locale
        if (locale === 'en') {
          months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
        } else if (locale === 'zh') {
          months = ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']
        }
      } catch (e) { /* ignore */ }
      return self.cruises.map(function (c) {
        var df = c.date_from ? new Date(c.date_from * 1000) : null
        var dt = c.date_to ? new Date(c.date_to * 1000) : null
        var depDate = df ? df.getDate() + ' ' + months[df.getMonth()] : ''
        var depTime = df ? String(df.getHours()).padStart(2, '0') + ':' + String(df.getMinutes()).padStart(2, '0') : ''
        var arrDate = dt ? dt.getDate() + ' ' + months[dt.getMonth()] : ''
        var arrTime = dt ? String(dt.getHours()).padStart(2, '0') + ':' + String(dt.getMinutes()).padStart(2, '0') : ''
        var stops = c.routes_array || []
        var oldPrice = c.discount && c.price_from ? Math.round(c.price_from / 100 / (1 - c.discount / 100)) : null
        var promoDate = ''
        if (c.discount && c.discount_exp) {
          var exp = new Date(c.discount_exp * 1000)
          promoDate = String(exp.getDate()).padStart(2, '0') + '.' + String(exp.getMonth() + 1).padStart(2, '0') + '.' + exp.getFullYear()
        }
        return {
          from: stops.length ? stops[0] : '',
          to: stops.length ? stops[stops.length - 1] : '',
          departureDate: depDate,
          departureTime: depTime,
          arrivalDate: arrDate,
          arrivalTime: arrTime,
          stops: stops,
          ship: c.ship ? c.ship.name : '',
          days: c.days || '',
          oldPrice: oldPrice ? String(oldPrice).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : '',
          price: c.price_from ? String(Math.round(c.price_from / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : '',
          discount: c.discount ? '-' + c.discount + '%' : '',
          promoDate: promoDate,
          image: c.ship && c.ship.image ? c.ship.image : '',
          tourLink: (c.ship && c.ship.link_3d_tour) ? c.ship.link_3d_tour : '',
          link: '/river-cruises/' + c.id + '/',
          cruiseId: c.id,
          year: c.year,
        }
      })
    },
  },
  mounted() {
    this.fetch(false)
  },
  methods: {
    buildQuery: function (filter, page) {
      var keys = ['id','departure','tag','ship_id','date_from','date_to','city_id','cruise_weekend','cruise_foreign','cruise_discount','price_from','price_to','duration_from','duration_to','class_of_ships','performed','archival']
      var parts = []
      keys.forEach(function (k) {
        var v = filter[k]
        if (Array.isArray(v) && v.length) {
          parts.push(encodeURIComponent('filter[' + k + ']') + '=' + encodeURIComponent(v.join(',')))
        } else if (!Array.isArray(v) && v !== undefined && v !== null && v !== '') {
          parts.push(encodeURIComponent('filter[' + k + ']') + '=' + encodeURIComponent(v))
        }
      })
      parts.push('sort_by=date_from&sort_direction=asc&page=' + page + '&per_page=10')
      return parts.join('&')
    },
    fetch: function (append) {
      var self = this
      self.loading = true
      var qs = self.buildQuery(self.filter || {}, self.page)
      axios.get('/api/v3/cruises/?' + qs).then(function (r) {
        var body = r.data || {}
        var data = body.data || []
        var pagination = body.pagination || {}
        if (append) {
          self.cruises = self.cruises.concat(data)
        } else {
          self.cruises = data
        }
        self.lastPage = pagination.last_page || 1
        self.loading = false
      }).catch(function () {
        self.loading = false
      })
    },
    loadMore: function () {
      this.page += 1
      this.fetch(true)
    },
  },
}
</script>

<style scoped>
.ndcl { margin: 32px 0; }
.ndcl__more {
  display: block;
  margin: 32px auto 0;
  padding: 14px 32px;
  background-color: var(--color-navy);
  color: var(--color-bg);
  border: none;
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  cursor: pointer;
  transition: background-color 0.15s;
}
.ndcl__more:hover { background-color: #1a3560; }
.ndcl__loading { display: flex; justify-content: center; padding: 40px 0; }
.ndcl__spinner {
  width: 36px; height: 36px;
  border: 3px solid #e8e5df;
  border-top-color: var(--color-navy);
  border-radius: 50%;
  animation: ndcl-spin 0.8s linear infinite;
}
@keyframes ndcl-spin { to { transform: rotate(360deg); } }
</style>
